export default __webpack_public_path__ + "static/past-perfect-8716e2ee921a6da5200f33aa4ef16061.svg";